module.exports = __webpack_public_path__ + "static/img/irole.0311f81.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/lxx/irole.png
// module id = z9JG
// module chunks = 7